import { action, observable, runInAction } from 'mobx';

import identityClient from '../clients/identityClient';

export default class UserStore {
  @observable accountId?: string;
  @observable email?: string;
  @observable hasLoaded: boolean = false; // whether a load has completed (including unsuccessfully)
  @observable locale?: string;
  @observable name?: string;
  @observable picture?: string;

  readyPromise: Promise<string>;
  rejectReady!: () => void;
  resolveReady!: (accountId: string) => void;

  constructor() {
    this.readyPromise = new Promise((resolve, reject) => {
      this.resolveReady = resolve;
      this.rejectReady = reject;
    });
  }

  @action
  async getUser() {
    try {
      const response = await identityClient.getUser();
      this.resolveReady(response.account_id);
      runInAction(() => {
        this.name = response.name;
        this.accountId = response.account_id;
        this.email = response.email;
        this.locale = response.locale;
        this.picture = response.picture;
        this.hasLoaded = true;
      });
    } catch (e) {
      // Don't want this error to propagate up
      this.rejectReady();
      runInAction(() => {
        this.hasLoaded = true;
      });
    }
  }
}
